// import Vue from 'vue';
import * as types from './mutationTypes';

/* eslint-disable no-param-reassign */
export default {
  [types.SET_AUTH](state, auth) {
    if (auth) {
      const { uid, email, photoURL, displayName } = auth;
      state.auth = { uid, email, photoURL, displayName };
    } else {
      state.auth = null;
    }
  },
  [types.SET_USER](state, user) {
    state.user = user;
  },
  [types.SET_POSTS](state, posts) {
    state.posts = posts;
    state.postsLoaded = true;
  },
  [types.CLEAR_POSTS](state) {
    state.posts = [];
    state.postsLoaded = false;
  },
  [types.SET_POST](state, post) {
    const postIndex = state.posts.findIndex(item => item.id === post.id);

    if (postIndex >= 0) {
      state.posts.splice(postIndex, 1, post);
    } else {
      state.posts.push(post);
    }
  },
  [types.SET_TARGET_ROUTE](state, route) {
    const { name, params } = route;
    state.targetRoute = { name, params };
  },
  [types.CLEAR_TARGET_ROUTE](state) {
    state.targetRoute = null;
  },
  [types.SET_GLOBAL_NOTIFICATION](state, notification) {
    state.globalNotification = notification;
  },
  [types.SET_UNREAD_NOTIFICATIONS_LIST](state, unreadNotifications) {
    state.unreadNotifications = unreadNotifications;
  },
};



// WEBPACK FOOTER //
// ./src/store/mutations.js